"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transLabel = exports["default"] = exports.TESTS = void 0;

var _buildMappings = _interopRequireDefault(require("./mappings/buildMappings"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/** ************************
 * HELPERS
 */


var _get = function _get(obj, key) {
  return (obj || {})[key];
};
/** ************************
 * ALL LABELS - check view definitions first, then fallback to general transforms
 */


var __transLabelWithFallbacks = function __transLabelWithFallbacks(label, MAPPINGS) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$customer = _ref.customer,
      customer = _ref$customer === void 0 ? 'NONE' : _ref$customer,
      _ref$abbrv = _ref.abbrv,
      abbrv = _ref$abbrv === void 0 ? false : _ref$abbrv,
      view = _ref.view;

  var BASEMAPPINGS = MAPPINGS[customer] || MAPPINGS.GENERAL;
  var BASEMAPPINGSVIEW = view && BASEMAPPINGS !== null && BASEMAPPINGS !== void 0 && BASEMAPPINGS.VIEWS[view] ? BASEMAPPINGS === null || BASEMAPPINGS === void 0 ? void 0 : BASEMAPPINGS.VIEWS[view] : BASEMAPPINGS;

  if (abbrv) {
    return _get(BASEMAPPINGSVIEW === null || BASEMAPPINGSVIEW === void 0 ? void 0 : BASEMAPPINGSVIEW.ABBRV, label) || _get(BASEMAPPINGS === null || BASEMAPPINGS === void 0 ? void 0 : BASEMAPPINGS.ABBRV, label) || _get(BASEMAPPINGSVIEW === null || BASEMAPPINGSVIEW === void 0 ? void 0 : BASEMAPPINGSVIEW.LABELS, label) || _get(BASEMAPPINGS === null || BASEMAPPINGS === void 0 ? void 0 : BASEMAPPINGS.LABELS, label) || label;
  }

  return _get(BASEMAPPINGSVIEW === null || BASEMAPPINGSVIEW === void 0 ? void 0 : BASEMAPPINGSVIEW.LABELS, label) || _get(BASEMAPPINGS === null || BASEMAPPINGS === void 0 ? void 0 : BASEMAPPINGS.LABELS, label) || label;
};
/** ************************
 * VIEW SPECIFIC LABELS ONLY - only check view definition label transforms
 */


var __transLabelViewDefinitionOnly = function __transLabelViewDefinitionOnly(label, MAPPINGS) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$customer = _ref2.customer,
      customer = _ref2$customer === void 0 ? 'NONE' : _ref2$customer,
      _ref2$abbrv = _ref2.abbrv,
      abbrv = _ref2$abbrv === void 0 ? false : _ref2$abbrv,
      view = _ref2.view;

  var BASEMAPPINGS = MAPPINGS[customer] || MAPPINGS.GENERAL;
  var BASEMAPPINGSVIEW = view && BASEMAPPINGS !== null && BASEMAPPINGS !== void 0 && BASEMAPPINGS.VIEWS[view] ? BASEMAPPINGS === null || BASEMAPPINGS === void 0 ? void 0 : BASEMAPPINGS.VIEWS[view] : {};

  if (abbrv) {
    return _get(BASEMAPPINGSVIEW === null || BASEMAPPINGSVIEW === void 0 ? void 0 : BASEMAPPINGSVIEW.ABBRV, label) || _get(BASEMAPPINGSVIEW === null || BASEMAPPINGSVIEW === void 0 ? void 0 : BASEMAPPINGSVIEW.LABELS, label) || label;
  }

  return _get(BASEMAPPINGSVIEW === null || BASEMAPPINGSVIEW === void 0 ? void 0 : BASEMAPPINGSVIEW.LABELS, label) || label;
};
/** ************************
 * MAIN
 */


var _transLabel = function _transLabel(label, MAPPINGS) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$customer = _ref3.customer,
      customer = _ref3$customer === void 0 ? 'NONE' : _ref3$customer,
      _ref3$abbrv = _ref3.abbrv,
      abbrv = _ref3$abbrv === void 0 ? false : _ref3$abbrv,
      view = _ref3.view,
      _ref3$viewDefinitionO = _ref3.viewDefinitionOnly,
      viewDefinitionOnly = _ref3$viewDefinitionO === void 0 ? false : _ref3$viewDefinitionO;

  return viewDefinitionOnly ? __transLabelViewDefinitionOnly(label, MAPPINGS, {
    customer: customer,
    abbrv: abbrv,
    view: view
  }) : __transLabelWithFallbacks(label, MAPPINGS, {
    customer: customer,
    abbrv: abbrv,
    view: view
  });
};
/** ************************
 * EXPORTS
 */


var createTransLabel = function createTransLabel() {
  var MAPPINGS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _buildMappings["default"];
  return function (label, config) {
    return _transLabel(label, MAPPINGS, config);
  };
};

var transLabel = createTransLabel();
exports.transLabel = transLabel;
var TESTS = {
  createTransLabel: createTransLabel
};
exports.TESTS = TESTS;
var _default = {
  transLabel: transLabel,
  TESTS: TESTS
};
exports["default"] = _default;